<template>
  <layout-admin-dashboard-view
    :show-toolbar="false"
    :back-route="{ name: 'admin-dashboard' }">
    <template #title>
      <span>{{ translateTitleCase("admin.media.dashboardTitle") }}</span>
    </template>

    <template #default>
      <div>
        <!--
        // work as a bucket or with pseudo folders
        :taxonomy-mode="'folder'" // or 'bucket'
        // root folder for this display
        :root-folder="/foo"
         // set initial folder other than root-folder, or set it while allowing media manager to go up from it
        :filters="{folder: '/foo'}"
         // will also work but not recommended
        :filters="{folder: '/foo/'}"
        // allows manual folder selection with text, and switching to bucket mode
        :enable-manual-folder-selection="true"
        // prevent user from switching to "bucket" mode
        :allow-taxonomy-mode-switch="false"

        // prevent user from navigating in folders
        // :allow-folder-navigation="false"

        // todo: last thing: what to do if bucket mode + folder? show all media or jsut the media in
        // todo: "create folder"
        -->
        <media-manager
          :media-select="false"
          :enable-manual-folder-selection="true"
          @media:item-selected="testMethod"></media-manager>
      </div>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";

export default {
  components: {},
  layout: "adminDashboard",
  middleware: {
    requireSuperAdmin: {},
  },
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "admin.media.dashboardBrowserTitle",
  data: function () {
    return {
      asyncData: {},
    };
  },
  computed: {},
  methods: {
    testMethod(val) {
     // console.log("slected", val);
    },
  },
};
</script>

<style scoped lang="scss"></style>
